// extracted by mini-css-extract-plugin
export default {"button":"Badge_button__BpuQ5","checked":"Badge_checked__RpiBR","normal":"Badge_normal__em6BZ","text":"Badge_text__95heu"};